// import $ from 'jquery';
// import 'jquery.easing';
// import videojs from 'video.js'
// import "video.js/dist/video-js.css"
// import { Header } from './components/Header.js';
// import { Contact } from './components/Contact.js';
// // import { SearchBox } from './components/SearchBox.js';
// // import { Product } from './components/Product.js';
// // import { Blog } from './components/Blog.js';
// import Slide from './components/Slide.js';
// import Swiper from 'swiper';
// import { Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import { mediaQuery, scrollTo } from './utils/functions.js';

// mediaQuery();
// const headerInstance = Header();
// Contact();

// Slide();

function requireAll(r){
  r.keys().forEach(r);
}

const pageHeader = document.querySelector('.lp25-site-wrapper .page-header');
const lastLookItem = document.querySelector('.lp25-site-wrapper .looks__item:last-child');
let lastLookItemY = 0;

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
}



window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);
// window.addEventListener('scroll', ()=>{
//   // get horizontal scroll position


// });

//check if the device is apple's product
// const isApple = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
// if(!isApple){
//   document.body.classList.add('no-apple');
// }


const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}

const siteWrapper = document.querySelector('.lp25-site-wrapper');

function applyFadeIn() {
  siteWrapper.classList.remove("loaded"); // 初期状態に戻す
  setTimeout(() => siteWrapper.classList.add("loaded"), 50); // 少し遅延させて適用
}

document.addEventListener("DOMContentLoaded", applyFadeIn);
window.addEventListener("load", applyFadeIn);
window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    applyFadeIn(); // キャッシュ復元時にも実行
  }
});

let st = window.scrollY;
window.addEventListener('scroll', ()=>{
  st = window.scrollY;
  if(st > 10){
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }


  let pageHeaderY = Math.min(0, (lastLookItemY - (st)) * 0.3);

  // console.log(pageHeaderY)

  if(lastLookItemY < st + window.innerHeight){
    pageHeader.style.transform = `${pageHeaderY}px`;
  } else {
    pageHeader.style.transform = `${pageHeaderY}px`;
  }

  let scrollX = window.scrollX;
  pageHeader.style.transform = `translate(-${scrollX}px, ${pageHeaderY}px)`;

});

// trigger scroll event
window.dispatchEvent(new Event('scroll'));


